module.exports = __webpack_public_path__ + "stripes.png";